(() => {
  const root = document.querySelector('[data-ap-site-callback]');
  if (!root || root.dataset.ready) return;
  const launcher = root.querySelector('[data-apsc-launcher]');
  const dialog = root.querySelector('dialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  root.dataset.ready = 'true';
  launcher.setAttribute('aria-haspopup', 'dialog');
  launcher.setAttribute('aria-controls', dialog.id);
  launcher.setAttribute('aria-expanded', 'false');
  const form = root.querySelector('form');
  const marker = 'ap-site-callback-submitted-at';
  let previousFocus;
  const open = () => {
    if (dialog.open) return;
    previousFocus = document.activeElement;
    dialog.showModal();
    launcher.setAttribute('aria-expanded', 'true');
    const target = dialog.querySelector('[data-apsc-errors], [data-apsc-success], #apsc-name');
    target?.focus({ preventScroll: true });
  };
  launcher.addEventListener('click', event => { event.preventDefault(); open(); });
  root.querySelector('[data-apsc-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    launcher.setAttribute('aria-expanded', 'false');
    if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
  });
  form?.addEventListener('submit', () => {
    try { sessionStorage.setItem(marker, String(Date.now())); } catch (_) {}
  });
  let submittedRecently = false;
  try { const at = Number(sessionStorage.getItem(marker)); submittedRecently = at > 0 && Date.now() - at < 1800000; } catch (_) {}
  const hasResult = !!dialog.querySelector('[data-apsc-success], [data-apsc-errors]');
  if (hasResult && (submittedRecently || location.hash === '#ap-site-callback-form')) {
    open();
    try { sessionStorage.removeItem(marker); } catch (_) {}
  }
  let chatHost, chatRoot, chatButton, frame;
  const align = () => {
    frame = null;
    const host = document.querySelector('shopify-chat');
    const shadow = host?.shadowRoot;
    if (host !== chatHost || shadow !== chatRoot) {
      chatHost = host; chatRoot = shadow;
      chatObserver.disconnect();
      if (shadow) chatObserver.observe(shadow, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-expanded', 'class', 'style'] });
    }
    const button = shadow?.querySelector('[part="activator"]');
    if (button !== chatButton) {
      sizeObserver?.disconnect(); chatButton = button;
      if (button) sizeObserver?.observe(button);
    }
    const r = button?.getBoundingClientRect();
    const shown = r && r.width > 0 && r.height > 0;
    const chatOpen = host && (!shown || button?.getAttribute('aria-expanded') === 'true');
    launcher.toggleAttribute('data-chat-open', !!chatOpen);
    if (shown && !chatOpen) {
      launcher.style.setProperty('--apsc-right', `${Math.max(12, document.documentElement.clientWidth - r.right)}px`);
      launcher.style.setProperty('--apsc-bottom', `${Math.max(80, window.innerHeight - r.top + 12)}px`);
    }
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(align); };
  const chatObserver = new MutationObserver(schedule);
  const sizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
  const mountObserver = new MutationObserver(schedule);
  mountObserver.observe(document.body, { childList: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', schedule);
  document.addEventListener('shopify:section:load', schedule);
  [0, 500, 1500, 3500].forEach(delay => setTimeout(schedule, delay));
})();
